// downloadableFrom arrives from the API as a UTC ISO string, e.g. "2026-10-16T12:00:00Z".
// Until that moment the API sends the book without its file.

// The earliest download opening still ahead among the listed books, as a timestamp,
// or null when there is none.
export const nextDownloadOpening = (library, now = Date.now()) =>
  library.reduce((next, book) => {
    const opensAt = book.downloadableFrom ? Date.parse(book.downloadableFrom) : NaN;

    return opensAt > now && (next === null || opensAt < next) ? opensAt : next;
  }, null);

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const pad = (value) => String(value).padStart(2, '0');

// "16 October 2026 at 12:00 UTC", whatever the visitor's own timezone or locale.
export const formatDownloadOpening = (moment) => {
  const date = new Date(moment);

  return `${date.getUTCDate()} ${MONTHS[date.getUTCMonth()]} ${date.getUTCFullYear()} at ${pad(
    date.getUTCHours(),
  )}:${pad(date.getUTCMinutes())} UTC`;
};
